import { render, staticRenderFns } from "./ButtonActionsHeader.vue?vue&type=template&id=606bc2e6"
import script from "./ButtonActionsHeader.vue?vue&type=script&lang=js"
export * from "./ButtonActionsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606bc2e6')) {
      api.createRecord('606bc2e6', component.options)
    } else {
      api.reload('606bc2e6', component.options)
    }
    module.hot.accept("./ButtonActionsHeader.vue?vue&type=template&id=606bc2e6", function () {
      api.rerender('606bc2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/details/components/ButtonActionsHeader.vue"
export default component.exports